import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getfacilitiesAPi, createfacilitiesAPi,  uploadfacilitiesAPi, deletefacilitiesApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create facilities
export const createfacilities = createAsyncThunk('createfacilities/facilities', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createfacilitiesAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatefacilities = createAsyncThunk('updatefacilities/facilities', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadfacilitiesAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get facilities
export const getfacilities = createAsyncThunk('getfacilities/facilities', async () => {
    try {
        const response = await axios.get(`${getfacilitiesAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'facilitiess' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete facilities
export const deletefacilitiess = createAsyncThunk('deletefacilitiess/facilities', async (facilitiesid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletefacilitiesApi}/${facilitiesid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'facilitiesid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const facilitiesSlice = createSlice({
    name: 'facilities',
    initialState: {
        facilitiess: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create facilities
            .addCase(createfacilities.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createfacilities.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createfacilities.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update facilities
            .addCase(updatefacilities.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatefacilities.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updatefacilities.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getfacilitiess
            .addCase(getfacilities.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getfacilities.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.facilitiess = action.payload;
            })
            .addCase(getfacilities.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete facilitiess
            .addCase(deletefacilitiess.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletefacilitiess.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.facilitiess.data = state.facilitiess.data.filter(facilitiess => facilitiess.facilitiesid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletefacilitiess.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default facilitiesSlice.reducer;
